import { render, staticRenderFns } from "./manageuser.vue?vue&type=template&id=2f184dfc&scoped=true&"
import script from "./manageuser.vue?vue&type=script&lang=js&"
export * from "./manageuser.vue?vue&type=script&lang=js&"
import style0 from "./manageuser.vue?vue&type=style&index=0&id=2f184dfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f184dfc",
  null
  
)

export default component.exports